import { useEffect } from "react";
import { ICnae } from "../../interfaces/ICnae";
import { Modal } from 'react-bootstrap-v5';

function CnaeImportarModal({ toggleModal, show, cnae }: { toggleModal: (recarregarInformacoes?: boolean) => void, show: boolean, cnae: ICnae}) {
    
  useEffect(() => {
      //Todo: Popular formulario e etc.
  }, [cnae]);
    
  return <Modal size='lg' centered={true} show={show} onHide={() => toggleModal()}>
    <div className="modal-content">
        <div className="modal-header">
            <h5 className="modal-title titulo-modal">Importar CNAEs</h5>
            <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                <i onClick={() => toggleModal()} className="fas fa-times" style={{ color: '#5E6397' }}/>
            </div>
        </div>
        <div className="modal-body">
            <form className="row g-3">
            <input style={{ display: 'none' }} id="inputFile" type="file" onChange={(e) => {
                    if (e.target.files !== null && e.target.files.length > 0) {
                        // const file = e.target.files[0];
                        // setFormularioCalendario({ ...formularioCalendario, file });
                    }
                }} />
                <div onClick={() => {
                    // const input = document.getElementById("inputFile");
                    // setFormularioCalendario({ ...formularioCalendario, file: null })
                    // input?.click();
                }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer' }}>
                    <div className="dropzone " id="upload">
                        <div className="mt-5 mb-5">

                            {/* {
                                formularioCalendario.file ? (
                                    <>
                                        <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '24px' }}> {formularioCalendario.file.name}</span>
                                    </>
                                ) :
                                    (<span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '24px' }}><i className="fas fa-upload fs-2x azul-agriholmes"></i> Enviar Arquivo</span>)
                            } */}
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div className="modal-footer" style={{ margin: '0 auto' }}>
            <button onClick={() => toggleModal()} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
            <button onClick={() => { }} type="button" className="btn btn-primario ms-5"> {cnae.id ? 'EDITAR' : 'ADICIONAR'} </button>
        </div>
    </div>
  </Modal>
}

export default CnaeImportarModal;